import { UserEntityPermissionsType } from '@/models/users/user-permissions/user-entity-permissions';

export class ClassificationSummary {
    public businessId: number = 0;
    public hasCategories: boolean = false;
    public hasCharacteristics: boolean = false;
    public hasAttributes: boolean = false;

    public get permissionsGroupType(): UserEntityPermissionsType {
        return UserEntityPermissionsType.Businesses;
    }

    public get permissionsIdToCheck(): number {
        return this.businessId;
    }

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(this, json);
    }
}
